import { defineComponent } from "vue";

import { COMPONENT_NAME } from "./attributes";

import { SharedWindow, SharedVerification } from "@/components/shared";
import { UIButton } from "@/components/ui";

import { CODE_MAX_LENGTH } from "@/shared/constants/constants";
import { RequisitesVerificationRequestFactory } from "@/shared/repository/modules/requisites/factory";
import { RequisitesType } from "@/shared/repository/modules/requisites/enums";
import { WalletModalFactory } from "@/shared/repository/modules/wallet/factory";
import { AdminApplicationType } from "@/shared/repository/modules/admin/application/enums";

export default defineComponent({
  name: COMPONENT_NAME,
  components: {
    SharedWindow,
    SharedVerification,
    UIButton,
  },
  emits: {
    close: null,
  },
  data() {
    return {
      isError: false,
      isLoading: false,
      code: "",
      requisitesRepository: this.$projectServices.requisitesRepository,
      walletRepo: this.$projectServices.walletRepo,
      depositWithdrawalRepo: this.$projectServices.depositWithdrawalRepo,
    };
  },
  computed: {
    isConfirmDisabled(): boolean {
      return this.isLoading || this.code.length !== CODE_MAX_LENGTH;
    },
  },
  methods: {
    async handleVerification(): Promise<void> {
      try {
        this.isError = false;
        this.isLoading = true;

        const bank = await this.requisitesRepository.verification(
          RequisitesVerificationRequestFactory({
            code: this.code,
            type: RequisitesType.bank,
          })
        );

        let type = AdminApplicationType.deposit;
        if (
          this.walletRepo.modal.type ===
          AdminApplicationType.verificationWithdrawal
        ) {
          type = AdminApplicationType.withdrawal;
        }

        this.walletRepo.UPDATE_MODAL(
          WalletModalFactory({
            type: type,
            bankId: bank?.id || 0,
          })
        );
      } catch (error) {
        this.isError = true;
      } finally {
        this.isLoading = false;
      }
    },

    handleClose(): void {
      this.$emit("close");
    },
  },
});
